export const baseURL = 'https://www.servicefun.cn'
// export const baseURL = 'http://192.168.0.79:8080'
// export const baseURL = 'http://192.168.1.62:8081'
// export const baseURL = 'http://192.168.0.177:8080'
// export const baseURL = 'http://test-service.serviceli.cn'

// export const baseURL = 'http://3qt5472829.picp.vip'
export const IPURL = 'http://47.104.23.195'